import React from 'react';

const Loading = (props)=>{
    return(
        <div className="loading d-none">
            <div className="d-flex flex-column align-items-center justify-content-center w-100 h-100"> 
                <h1><i className="fa fa-spinner"></i></h1>
                <p>Generating your pdf ...</p>
            </div>
        </div>
    )
}

export default Loading;


// WEBPACK FOOTER //
// ./src/view/Loading.js